import { render, staticRenderFns } from "./label_remark.vue?vue&type=template&id=29dde5bb&scoped=true"
import script from "./label_remark.vue?vue&type=script&lang=js"
export * from "./label_remark.vue?vue&type=script&lang=js"
import style0 from "./label_remark.vue?vue&type=style&index=0&id=29dde5bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29dde5bb",
  null
  
)

export default component.exports